import { useTranslation } from 'react-i18next';

import { RichTextEditor as BaseRichTextEditor } from '@valwin/facto/components';

const BoldButton = () => {
  const { t } = useTranslation();

  return (
    <BaseRichTextEditor.BoldButton
      label={t('richTextEditor bold')}
      ariaLabel={t('richTextEditor bold')}
    />
  );
};

const ItalicButton = () => {
  const { t } = useTranslation();

  return (
    <BaseRichTextEditor.ItalicButton
      label={t('richTextEditor italic')}
      ariaLabel={t('richTextEditor italic')}
    />
  );
};

const UnderlineButton = () => {
  const { t } = useTranslation();

  return (
    <BaseRichTextEditor.UnderlineButton
      label={t('richTextEditor underline')}
      ariaLabel={t('richTextEditor underline')}
    />
  );
};

const H1Button = () => {
  const { t } = useTranslation();

  return (
    <BaseRichTextEditor.H1Button
      label={t('richTextEditor h1')}
      ariaLabel={t('richTextEditor h1')}
    />
  );
};

const H2Button = () => {
  const { t } = useTranslation();

  return (
    <BaseRichTextEditor.H2Button
      label={t('richTextEditor h2')}
      ariaLabel={t('richTextEditor h2')}
    />
  );
};

const BulletListButton = () => {
  const { t } = useTranslation();

  return (
    <BaseRichTextEditor.BulletListButton
      label={t('richTextEditor bulletList')}
      ariaLabel={t('richTextEditor bulletList')}
    />
  );
};

const OrderedListButton = () => {
  const { t } = useTranslation();

  return (
    <BaseRichTextEditor.OrderedListButton
      label={t('richTextEditor orderedList')}
      ariaLabel={t('richTextEditor orderedList')}
    />
  );
};

const QuoteButton = () => {
  const { t } = useTranslation();

  return (
    <BaseRichTextEditor.QuoteButton
      label={t('richTextEditor quote')}
      ariaLabel={t('richTextEditor quote')}
    />
  );
};

const UndoButton = () => {
  const { t } = useTranslation();

  return (
    <BaseRichTextEditor.UndoButton
      label={t('richTextEditor undo')}
      ariaLabel={t('richTextEditor undo')}
    />
  );
};

const RedoButton = () => {
  const { t } = useTranslation();

  return (
    <BaseRichTextEditor.RedoButton
      label={t('richTextEditor redo')}
      ariaLabel={t('richTextEditor redo')}
    />
  );
};

export {
  BoldButton,
  BulletListButton,
  H1Button,
  H2Button,
  ItalicButton,
  OrderedListButton,
  QuoteButton,
  RedoButton,
  UnderlineButton,
  UndoButton,
};
